/**
 * Approximate GTO preflop opening (RFI) ranges by position.
 * These are simplified ranges based on common 100bb 6-max charts.
 * Hands listed are those that should be opened from each position.
 */

export const GTO_OPEN_RANGES: Record<string, string[]> = {
  UTG: [
    'AA','KK','QQ','JJ','TT','99','88','77',
    'AKs','AQs','AJs','ATs','A5s','A4s',
    'KQs','KJs','KTs',
    'QJs','QTs',
    'JTs',
    'AKo','AQo',
  ],
  'UTG+1': [
    'AA','KK','QQ','JJ','TT','99','88','77','66',
    'AKs','AQs','AJs','ATs','A9s','A5s','A4s','A3s',
    'KQs','KJs','KTs',
    'QJs','QTs',
    'JTs','T9s',
    'AKo','AQo','AJo',
  ],
  MP: [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55',
    'AKs','AQs','AJs','ATs','A9s','A8s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s',
    'QJs','QTs','Q9s',
    'JTs','J9s',
    'T9s',
    '98s',
    'AKo','AQo','AJo','ATo',
  ],
  'MP+1': [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55',
    'AKs','AQs','AJs','ATs','A9s','A8s','A7s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s',
    'QJs','QTs','Q9s',
    'JTs','J9s',
    'T9s',
    '98s','87s',
    'AKo','AQo','AJo','ATo',
    'KQo',
  ],
  HJ: [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55','44',
    'AKs','AQs','AJs','ATs','A9s','A8s','A7s','A6s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s','K8s',
    'QJs','QTs','Q9s',
    'JTs','J9s','J8s',
    'T9s','T8s',
    '98s','87s','76s',
    'AKo','AQo','AJo','ATo',
    'KQo','KJo',
  ],
  CO: [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55','44','33','22',
    'AKs','AQs','AJs','ATs','A9s','A8s','A7s','A6s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s','K8s','K7s','K6s',
    'QJs','QTs','Q9s','Q8s',
    'JTs','J9s','J8s',
    'T9s','T8s',
    '98s','97s',
    '87s','76s','65s','54s',
    'AKo','AQo','AJo','ATo','A9o',
    'KQo','KJo','KTo',
    'QJo','QTo',
    'JTo',
  ],
  BTN: [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55','44','33','22',
    'AKs','AQs','AJs','ATs','A9s','A8s','A7s','A6s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s','K8s','K7s','K6s','K5s','K4s','K3s','K2s',
    'QJs','QTs','Q9s','Q8s','Q7s','Q6s',
    'JTs','J9s','J8s','J7s',
    'T9s','T8s','T7s',
    '98s','97s','96s',
    '87s','86s',
    '76s','75s',
    '65s','64s',
    '54s','53s',
    '43s',
    'AKo','AQo','AJo','ATo','A9o','A8o','A7o','A6o','A5o','A4o','A3o','A2o',
    'KQo','KJo','KTo','K9o',
    'QJo','QTo','Q9o',
    'JTo','J9o',
    'T9o',
    '98o',
  ],
  SB: [
    'AA','KK','QQ','JJ','TT','99','88','77','66','55','44','33','22',
    'AKs','AQs','AJs','ATs','A9s','A8s','A7s','A6s','A5s','A4s','A3s','A2s',
    'KQs','KJs','KTs','K9s','K8s','K7s','K6s','K5s','K4s',
    'QJs','QTs','Q9s','Q8s','Q7s',
    'JTs','J9s','J8s','J7s',
    'T9s','T8s','T7s',
    '98s','97s',
    '87s','86s',
    '76s','75s',
    '65s','64s',
    '54s',
    'AKo','AQo','AJo','ATo','A9o','A8o','A7o','A6o','A5o','A4o',
    'KQo','KJo','KTo','K9o',
    'QJo','QTo',
    'JTo','J9o',
    'T9o',
  ],
  BB: [], // BB defends vs raises — different concept, leave empty
};

export const GTO_POSITIONS = Object.keys(GTO_OPEN_RANGES).filter(p => GTO_OPEN_RANGES[p].length > 0);
